import { render, staticRenderFns } from "./BusinessMemberPlanResume.vue?vue&type=template&id=b4883ab0"
import script from "./BusinessMemberPlanResume.vue?vue&type=script&lang=js"
export * from "./BusinessMemberPlanResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports